import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { decrypt } from '../../../../utils/encryption'
import { NavContext } from '../../../../context/global_context'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import {
  FunctionalDiagramEditContext,
  SET_FUNCTIONAL_DIAGRAM_DETAILS,
  SET_FUNCTIOANAL_MAPPING_SEARCH_DATA,
  SET_SEARCHING_STATUS,
} from './context/context'
import { getRequest } from '../../../../services/base'
import ComponentSearchPins from './ComponentSearchPins'
import SelectConnectSection from './SelectConnectSection'
import SearchResult from './SearchResult'
import FunctionalDiagramForm from '../form'
import FunctionalDiagramPreview from './preview'

const FunctionalDiagramEdit = () => {
  const { functional, vehicle } = useParams()
  const [navState, navDispatch] = useContext(NavContext)
  const [searchValue, setSearchValue] = useState('')
  const [state, dispatch] = useContext(FunctionalDiagramEditContext)
  const [showFunctioanlModal, setShowFunctioanlModal] = useState(false)

  useEffect(() => {
    getFunctionalDiagramDetails()
  }, [])

  const getSearchData = async () => {
    dispatch({
      type: SET_FUNCTIOANAL_MAPPING_SEARCH_DATA,
      data: {
        data: [],
        selectedSection: { type: 'connectors', data: [] },
      },
    })

    dispatch({
      type: SET_SEARCHING_STATUS,
      data: true,
    })
    let res = await getRequest(
      `/api/vehicles/global-search/${vehicle}/?search=${searchValue}`
    )
    dispatch({
      type: SET_FUNCTIOANAL_MAPPING_SEARCH_DATA,
      data: {
        data: res.data,
        selectedSection: { type: 'connectors', data: res.data?.connectors },
      },
    })
  }

  const getFunctionalDiagramDetails = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Functional Diagram Details',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/sub_system/${decrypt(functional)}/?make=${vehicle}`
    )
    getFunctionalDiagramConnectors(res)
  }

  const getFunctionalDiagramConnectors = async (functional_diagram_details) => {
    let res = await getRequest(
      `/api/sub_system/functional-diagram-connector/${decrypt(functional)}/?make=${vehicle}`
    )
    dispatch({
      type: SET_FUNCTIONAL_DIAGRAM_DETAILS,
      data: { ...functional_diagram_details, sales_code_data: res.sales_code },
      mappedConnector: res.data,
      connectorCategories: res.category,
    })

    navDispatch({
      type: 'header',
      data: {
        header: `${vehicle}`,
        sub_header: `${functional_diagram_details?.sub_system_id} - ${functional_diagram_details?.name}`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: `/vehicles/${vehicle}/functional-diagram`,
        full_width_container: true,
      },
    })
  }

  return (
    <div className="w-full">
      {showFunctioanlModal && (
        <FunctionalDiagramForm
          showModal={showFunctioanlModal}
          setShowModal={setShowFunctioanlModal}
          getFunctionalDiagramList={() => {}}
          selectedFunctionalDiagram={state.functionalDiagramDetails}
          onSave={() => {
            setShowFunctioanlModal(false)
            getFunctionalDiagramConnectors(state.functionalDiagramDetails)
          }}
          onClose={() => {
            setShowFunctioanlModal(false)
          }}
        />
      )}

      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div
          className={`flex space-x-5 justify-center content-center items-center`}
        >
          <div
            className={`flex items-center w-1/3 false px-3 ${functional === 'new' && 'disabled'}`}
          >
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Device, Connector, Circuit...`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
            </div>
            <Button
              className={`cursor-pointer btn my-4 justify-end`}
              text={`Search`}
              onClick={() => {
                getSearchData()
              }}
            />
          </div>
          <Button
            className={`cursor-pointer btn my-4 justify-end`}
            text={`Add Sales Code`}
            onClick={() => {
              setShowFunctioanlModal(true)
            }}
          />
          <FunctionalDiagramPreview />
        </div>
      </form>
      <div
        className={`flex px-2 bg-tracer-chrome-blue ${functional === 'new' && 'disabled'}`}
        style={{ height: '80vh' }}
      >
        <div
          className="flex justify-center  px-3 py-5"
          style={{ borderRight: '1px solid #909294', width: '37.5%' }}
        >
          <SearchResult />
        </div>
        <div
          className="w-1/3 py-5"
          style={{
            borderRight: '1px solid #909294',
            width: '25%',
          }}
        >
          <SelectConnectSection />
        </div>
        <div
          className="bg-tracer-chrome-blue py-5 px-3 flex justify-center"
          style={{ width: '37.5%' }}
        >
          <ComponentSearchPins />
        </div>
      </div>
    </div>
  )
}

export default FunctionalDiagramEdit
